import { render, staticRenderFns } from "./we-goods-view.vue?vue&type=template&id=021a9131&scoped=true&"
import script from "./we-goods-view.vue?vue&type=script&lang=js&"
export * from "./we-goods-view.vue?vue&type=script&lang=js&"
import style0 from "./we-goods-view.vue?vue&type=style&index=0&id=021a9131&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "021a9131",
  null
  
)

export default component.exports